import React, { Component } from "react";
import { NavLink } from "react-router-dom";

export default class Header extends Component {
	render() {
		return (
			<div id="header">
				<div className="white-background">
					<div className="nav-header primary-background">
						<div className="centered-text medium-padding">
							<NavLink to="/">
								<img className="three-quarter-width" src="/img/logo.png" alt="Alpine" />
							</NavLink>
						</div>
					</div>
          <nav>
						<NavLink to="/">{'Search'}</NavLink>
            <NavLink to="/units">{'Units'}</NavLink>
						<NavLink to="/" onClick={this.props.logOutUser}>
							{'Logout'}
						</NavLink>
          </nav>
				</div>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/components/header.js